import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

import Logo from 'components/Logo/Logo';

import { getHomePage } from 'store/app/selectors';
import { getIsLoggedIn } from 'store/session/selectors';

import NavDropdown from './NavDropDown';

const Wrapper = styled.nav`
  padding: 13px 30px 13px 15px;
  background: white;
  border-bottom: 1px solid #ddd;

  @media (max-width: 899px) {
    display: none;
  }

  font-family: Libre Franklin;
`;

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const StyledLogo = styled(Logo)`
  width: 176px;
  height: 52px;
  margin-left: 15px;
  margin-right: 15px;
`;

const Menu = styled.ul`
  flex-shrink: 0;
  display: flex;
  align-items: center;
  margin: 0;
  font-family: Montserrat;
  font-size: 14px;

  li {
    padding-left: 15px;
    color: #666;

    > a,
    button {
      border-radius: 1px;
      text-decoration: none;

      &:focus {
        box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.3);
      }
    }
  }
`;

const NavLink = styled(Link)`
  padding: 3px 5px;
  line-height: 22px;
  cursor: pointer;
  transition: color 200ms ease;

  &:hover {
    color: #ff771a;
  }
`;

const RightSide = styled.div`
  display: flex;
  flex-direction: row;
`;

const connector = connect((state) => ({
  homePage: getHomePage(state),
  isLoggedIn: getIsLoggedIn(state),
}));

const Header = ({ homePage, isLoggedIn }) => {
  return (
    <Wrapper>
      <Container>
        <Link to={homePage}>
          <StyledLogo />
        </Link>
        <RightSide>
          <Menu>
            {!isLoggedIn && (
              <li>
                <NavLink to="/login">Login</NavLink>
              </li>
            )}

            {isLoggedIn && (
              <li>
                <NavDropdown />
              </li>
            )}
          </Menu>
        </RightSide>
      </Container>
    </Wrapper>
  );
};

export default connector(Header);
